module.exports = __webpack_public_path__ + "img/back-icon01.32bb3fcd.png";